import React, { useState, useEffect, useRef } from 'react'

const { detect } = require('detect-browser')
const browser = detect()
const linkUpdateNav = 'http://www.updateyourbrowser.net/fr'		
const showBoxInfos = browser && browser.os.indexOf('Windows') !== false && browser.name === 'ie' && parseInt(browser.version) < 11

const BrowserCheck = () => {
	const [isVisible, setIsVisible] = useState(showBoxInfos)
	const alertRef = useRef(null)

	useEffect(() => {
		if (isVisible && alertRef.current) {
			alertRef.current.focus()
		}
	}, [isVisible])

	const handleClose = () => {
		setIsVisible(false)
	}

	const handleKeyDown = (event) => {
		if (event.key === 'Escape') {
			handleClose()
		}
	}

	if (!isVisible) {
		return null
	}

	return (
		<div 
			className="browser-check-alert-message alert alert-danger" 
			role="alert"
			aria-live="assertive"
			aria-labelledby="browser-alert-title"
			ref={alertRef}
			tabIndex="-1"
			onKeyDown={handleKeyDown}
		>
			<div className="d-flex justify-content-between align-items-start">
				<div>
					<h4 id="browser-alert-title" className="alert-heading">
						Votre navigateur est obsolète !
					</h4>
					<p>
						Vous utilisez une ancienne version de <strong>{browser.name}</strong> ({browser.version}). 
						Pour la meilleure expérience, veuillez{' '}
						<a 
							className="alert-link" 
							href={linkUpdateNav} 
							target="_blank" 
							rel="noopener noreferrer"
							aria-label={`Actualiser votre navigateur (s'ouvre dans un nouvel onglet)`}
						>
							actualiser votre navigateur
						</a>
					</p>
				</div>
				<button
					type="button"
					className="btn-close"
					aria-label="Fermer l'alerte de navigateur obsolète"
					onClick={handleClose}
					onKeyDown={(e) => {
						if (e.key === 'Enter' || e.key === ' ') {
							e.preventDefault()
							handleClose()
						}
					}}
				>
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
		</div>
	)
		}

export default BrowserCheck